import service from '@/services/SIRsic_sal_nvg';

export default {
  namespaced: true,

  actions: {
    /**
     * Petición para obtener las salas relacionadas (sub-salas) con una sala en particular.
     */
    async read({ dispatch, rootGetters }, values) {
      return new Promise((resolve, reject) => {
        const payload = {
          dsSIRsic_sal_nvg: {
            eeDatos: [rootGetters['auth/state']],
            eeSIRsic_sal_nvg: [
              {
                piisal_cod: values.piisal_cod,
                pilsal_par: values?.pilsal_par === true,
              },
            ],
          },
        };

        let notification;

        service
          .read(payload)
          .then((response) => {
            const data = response.data.dsSIRsic_sal_nvg;

            if (data.eeEstados[0].Returnid === 0) {
              resolve(data?.eesic_sal_nvg);
            } else if (data.eeEstados[0].Returnid === 98) {
              resolve([]);
            } else {
              notification = {
                code: data.eeEstados[0].Returnid,
                message: data.eeEstados[0].Estado,
                timestamp: Date.now(),
                type: 'error',
              };

              throw notification;
            }
          })
          .catch((error) => {
            if (error.type === undefined) {
              notification = {
                code: undefined,
                message: error.message,
                timestamp: Date.now(),
                type: 'error',
              };
            }

            dispatch('notification/create', notification, {
              root: true,
            });

            reject(notification);
          });
      });
    },
  },
};
